module.exports = (
  require('../../module.compiled') as typeof import('../../module.compiled')
).vendored['react-ssr']!.ReactDOMServer
